module.exports = {"360723100":"南安镇","360723101":"新城镇","360723102":"樟斗镇","360723103":"池江镇","360723104":"青龙镇","360723105":"左拔镇","360723106":"黄龙镇","360723107":"吉村镇","360723200":"浮江乡","360723201":"河洞乡","360723202":"内良乡","360723400":"新世纪工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360723.json
// module id = 1403
// module chunks = 0